import request from '@/utils/request'
// Dock Status
export function dockStatus(param) {
    let data = param
    return request({
      url: `/v20/dockStatus`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
}
// Dock Chart
export function dockChart(param) {
  let data = param
  return request({
    url: `/v20/dockChart`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// Daily Manpower
export function dailyManpower() {
  let data = ""
  return request({
    url: `/v20/dailyManpower`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// Blasting Block List
export function blastingBlockList() {
  let data = ""
  return request({
    url: `/v20/blastingBlockList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// Inspection Block List
export function inspectionBlockList() {
  let data = ""
  return request({
    url: `/v20/inspectionBlockList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

